module.exports = __webpack_public_path__ + "static/img/gongdang.1f268d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gongdang.png
// module id = 5MBu
// module chunks = 1